import { Component } from '@angular/core';

import { AuthService } from '../shared/auth.service';

@Component({
    selector: 'app-claims',
    templateUrl: './claims.component.html'
})
export class ClaimsComponent {
    public userInfo: any;
    constructor(authService: AuthService) {
        this.userInfo = authService.getUserInfo();

    }

    public getKeys(): string[] {
        return Object.keys(this.userInfo);
    }

    public getValue(key: string): any {
        return this.userInfo[key];
    }
}
